<template>
  <b-container class="text-block privacy">
    <b-row>
      <b-col>
        <h2>Datenschutzerklärung</h2>
        <p class="text-muted">Stand: August 2026</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="8">
        <b-card class="privacy-card" body-class="p-4">
          <p class="privacy-org">
            Evangelische Kinder- und Jugendarbeit im Kirchenkreis Mühlhausen
            (Jugendkirche Mühlhausen)
          </p>
          <p class="text-muted privacy-role">
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO)
          </p>

          <ul class="privacy-details list-unstyled mb-0">
            <li>
              <b-icon-person></b-icon-person>
              <span>Elisabeth Dauphin</span>
            </li>
            <li>
              <b-icon-geo-alt></b-icon-geo-alt>
              <address class="mb-0">
                August-Bebel-Str. 66<br />
                99974 Mühlhausen
              </address>
            </li>
            <li>
              <b-icon-telephone></b-icon-telephone>
              <a href="tel:+4917664614205">0176 / 646 14 205</a>
            </li>
            <li>
              <b-icon-envelope></b-icon-envelope>
              <a href="mailto:elisabeth.dauphin@ekmd.de"
                >elisabeth.dauphin@ekmd.de</a
              >
            </li>
          </ul>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col lg="12">
        <section class="privacy-section">
          <h4>1. Allgemeines</h4>
          <p>
            Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz
            Ihrer personenbezogenen Daten ist uns wichtig. Diese
            Datenschutzerklärung informiert Sie darüber, welche Daten bei
            einem Besuch unserer Website verarbeitet werden, zu welchem Zweck
            dies geschieht und welche Rechte Ihnen dabei zustehen. Der Besuch
            unserer Website ist grundsätzlich ohne Angabe personenbezogener
            Daten möglich; nur wenn Sie uns per E-Mail oder Telefon
            kontaktieren, werden Daten in dem dafür erforderlichen Umfang
            verarbeitet.
          </p>
          <p>
            Eine automatisierte Entscheidungsfindung oder ein Profiling
            findet nicht statt.
          </p>
        </section>

        <section class="privacy-section">
          <h4>2. Begriffsbestimmungen</h4>
          <p>
            Diese Datenschutzerklärung verwendet die Begriffe der
            Datenschutz-Grundverordnung (Art. 4 DS-GVO):
          </p>
          <ul>
            <li>
              <strong>Personenbezogene Daten</strong> sind alle Informationen,
              die sich auf eine identifizierte oder identifizierbare
              natürliche Person („betroffene Person“) beziehen.
            </li>
            <li>
              <strong>Verarbeitung</strong> ist jeder Vorgang im Zusammenhang
              mit personenbezogenen Daten, etwa das Erheben, Speichern,
              Verwenden oder Löschen.
            </li>
            <li>
              <strong>Verantwortlicher</strong> ist die Stelle, die über die
              Zwecke und Mittel der Verarbeitung personenbezogener Daten
              entscheidet.
            </li>
            <li>
              <strong>Einwilligung</strong> ist jede freiwillig, informiert
              und unmissverständlich abgegebene Willensbekundung, mit der die
              betroffene Person die Verarbeitung sie betreffender
              personenbezogener Daten gestattet.
            </li>
          </ul>
        </section>

        <section class="privacy-section">
          <h4>3. Hosting und Server-Logfiles</h4>
          <p>
            Beim Aufruf unserer Website erhebt der Webserver automatisiert
            Daten und Informationen, die Ihr Browser übermittelt, unter
            anderem Browsertyp und -version, verwendetes Betriebssystem,
            Referrer-URL, aufgerufene Unterseiten, Datum und Uhrzeit des
            Zugriffs sowie die IP-Adresse. Diese Daten werden in Logfiles
            gespeichert und dienen ausschließlich dazu, die Website
            technisch fehlerfrei und sicher auszuliefern sowie im Falle von
            Angriffen auf unsere Systeme deren Herkunft nachvollziehen zu
            können. Eine Zusammenführung mit anderen Datenquellen oder eine
            Auswertung zu Marketingzwecken findet nicht statt.
          </p>
          <p>
            Wir setzen auf unserer Website keine Cookies und keine
            vergleichbaren Tracking- oder Analysewerkzeuge (z. B. Google
            Analytics) ein.
          </p>
        </section>

        <section class="privacy-section">
          <h4>4. Kontaktaufnahme</h4>
          <p>
            Im Impressum und im Seitenfuß stellen wir eine E-Mail-Adresse und
            eine Telefonnummer für die Kontaktaufnahme bereit. Wenn Sie uns
            auf diesem Weg kontaktieren, verarbeiten wir die von Ihnen
            übermittelten Daten (z. B. Name, E-Mail-Adresse, Nachrichteninhalt)
            ausschließlich zur Bearbeitung Ihrer Anfrage. Eine Weitergabe an
            Dritte erfolgt nicht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
            DS-GVO (Beantwortung Ihrer Anfrage) bzw. Art. 6 Abs. 1 lit. a
            DS-GVO, sofern Sie uns Ihre Einwilligung erteilt haben.
          </p>
        </section>

        <section class="privacy-section">
          <h4>5. Speicherdauer</h4>
          <p>
            Wir speichern personenbezogene Daten nur so lange, wie es für den
            jeweiligen Verarbeitungszweck erforderlich ist oder gesetzliche
            Aufbewahrungsfristen dies vorschreiben. Server-Logfiles werden
            nach kurzer Zeit automatisiert gelöscht, sofern sie nicht zur
            Aufklärung eines konkreten Sicherheitsvorfalls benötigt werden.
            Daten aus einer Kontaktaufnahme löschen wir, sobald Ihre Anfrage
            abschließend bearbeitet ist und keine gesetzliche
            Aufbewahrungspflicht entgegensteht.
          </p>
        </section>

        <section class="privacy-section">
          <h4>6. Rechtsgrundlagen der Verarbeitung</h4>
          <ul>
            <li>
              <strong>Art. 6 Abs. 1 lit. a DS-GVO</strong> – wenn Sie uns eine
              Einwilligung zu einem bestimmten Verarbeitungszweck erteilt
              haben.
            </li>
            <li>
              <strong>Art. 6 Abs. 1 lit. c DS-GVO</strong> – wenn eine
              rechtliche Verpflichtung die Verarbeitung erforderlich macht.
            </li>
            <li>
              <strong>Art. 6 Abs. 1 lit. f DS-GVO</strong> – wenn die
              Verarbeitung zur Wahrung eines berechtigten Interesses
              erforderlich ist, sofern Ihre Interessen und Grundrechte nicht
              überwiegen. Unser berechtigtes Interesse liegt in einem
              technisch fehlerfreien und sicheren Betrieb unserer Website.
            </li>
          </ul>
        </section>

        <section class="privacy-section">
          <h4>7. Ihre Rechte als betroffene Person</h4>
          <p>Ihnen stehen als betroffene Person folgende Rechte zu:</p>
          <ul>
            <li>
              <strong>Auskunft</strong> über die zu Ihrer Person
              gespeicherten Daten (Art. 15 DS-GVO)
            </li>
            <li>
              <strong>Berichtigung</strong> unrichtiger Daten (Art. 16
              DS-GVO)
            </li>
            <li>
              <strong>Löschung</strong> Ihrer Daten (Art. 17 DS-GVO)
            </li>
            <li>
              <strong>Einschränkung der Verarbeitung</strong> (Art. 18
              DS-GVO)
            </li>
            <li>
              <strong>Datenübertragbarkeit</strong> (Art. 20 DS-GVO)
            </li>
            <li>
              <strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21
              DS-GVO)
            </li>
            <li>
              <strong>Widerruf</strong> einer erteilten Einwilligung mit
              Wirkung für die Zukunft (Art. 7 Abs. 3 DS-GVO)
            </li>
            <li>
              <strong>Beschwerde bei einer Aufsichtsbehörde</strong>, z. B.
              beim Thüringer Landesbeauftragten für den Datenschutz und die
              Informationsfreiheit (Art. 77 DS-GVO)
            </li>
          </ul>
          <p>
            Zur Ausübung dieser Rechte können Sie sich jederzeit über die
            oben genannten Kontaktdaten an uns wenden.
          </p>
        </section>

        <section class="privacy-section">
          <h4>8. Verlinkung zu sozialen Netzwerken</h4>
          <p>
            Auf unserer Website verlinken wir auf unsere Profile bei Facebook
            und Instagram. Dabei handelt es sich um einfache Hyperlinks ohne
            eingebundene Social-Plugins; beim Besuch unserer Website werden
            dadurch keine Daten an diese Anbieter übertragen. Erst wenn Sie
            aktiv auf einen Link klicken und die jeweilige Plattform
            besuchen, gelten die Datenschutzbestimmungen des jeweiligen
            Anbieters (Meta Platforms Ireland Limited, 4 Grand Canal Square,
            Grand Canal Harbour, Dublin 2, Irland, für Facebook und
            Instagram).
          </p>
        </section>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Datenschutz"
};
</script>

<style lang="scss" scoped>
.privacy {
  margin-top: 100px;
  margin-bottom: 80px;
  font-size: 1rem;
  line-height: 1.7;
}

.privacy-card {
  border-left: 4px solid #d9230f;
  margin-bottom: 1rem;
}

.privacy-org {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 0.15rem;
}

.privacy-role {
  font-size: 0.85rem;
  margin-bottom: 1.25rem;
}

.privacy-details {
  li {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  svg {
    flex-shrink: 0;
    margin-top: 0.2rem;
    color: #d9230f;
  }

  address {
    font-style: normal;
  }
}

.privacy-section {
  margin-top: 2.5rem;

  &:first-of-type {
    margin-top: 0;
  }

  h4 {
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
    border-bottom: 2px solid #d9230f;
  }

  ul {
    padding-left: 1.25rem;

    li {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
